// ─── DateRangeFilter ───────────────────────────────────────────────────────────
// Props: filters = { fromDate, toDate }
//        onChange(newFilters)
//        label (optional string)

export function DateRangeFilter({ filters, onChange, label = 'date' }) {
  const set = (key, val) => onChange({ ...filters, [key]: val });
  const clear = () => onChange({ fromDate: '', toDate: '' });
  const hasAny = filters.fromDate || filters.toDate;

  return (
    <div className="date-range-filter">
      {label && <span className="date-range-label">{label}:</span>}
      <div className="date-range-group">
        <span className="date-range-caption">From</span>
        <input
          type="date"
          className="date-select"
          value={filters.fromDate || ''}
          onChange={e => set('fromDate', e.target.value)}
        />
      </div>

      <div className="date-range-group">
        <span className="date-range-caption">To</span>
        <input
          type="date"
          className="date-select"
          value={filters.toDate || ''}
          onChange={e => set('toDate', e.target.value)}
        />
      </div>

      {hasAny && (
        <button className="date-clear-btn" onClick={clear} title="Clear date filters">
          ✕ Clear
        </button>
      )}
    </div>
  );
}

// ─── ExportBar ─────────────────────────────────────────────────────────────────
// Props: onExport(format)  — called with 'csv' or 'excel'
//        total             — number of matching records
//        canExport         — boolean permission check
export function ExportBar({ onExport, total, canExport }) {
  if (!canExport) return null;
  return (
    <div className="export-bar">
      <span className="export-count">
        {total != null ? `${Number(total).toLocaleString('en-IN')} records match` : ''}
      </span>
      <div className="export-buttons">
        <button className="export-btn export-btn--csv"  onClick={() => onExport('csv')}>
          ↓ CSV
        </button>
        <button className="export-btn export-btn--excel" onClick={() => onExport('excel')}>
          ↓ Excel
        </button>
      </div>
    </div>
  );
}
